import React from 'react'
import { IconDelete } from './Icon'

interface SelectedTag {
  label: string
  value: string
  section: string
  queryKey: string
}

interface SelectedTagsBarProps {
  tags: SelectedTag[]
  onRemove: (tag: SelectedTag) => void
}

export const SelectedTagsBar: React.FC<SelectedTagsBarProps> = ({ tags, onRemove }) => {
  if (!tags.length) return null
  return (
    <div className="w-full overflow-x-auto" style={{ WebkitOverflowScrolling: 'touch' }}>
      <div className="flex flex-nowrap gap-2" style={{ minHeight: 40 }}>
        {tags.map((tag) => (
          <span
            key={tag.queryKey + '-' + tag.value}
            className="flex items-center border border-green text-green rounded-full px-4 py-2 whitespace-nowrap font-noto bg-white"
            style={{ fontSize: 12, lineHeight: '18px', fontWeight: 'normal' }}
          >
            {tag.label}
            <button
              type="button"
              className="flex items-center ml-1.5 text-green hover:opacity-70 focus:outline-hidden"
              aria-label="タグを削除"
              onClick={() => onRemove(tag)}
              style={{ background: 'none', border: 'none', padding: 0, minWidth: 16, minHeight: 16 }}
            >
              <IconDelete style={{ display: 'block', minWidth: 16, minHeight: 16 }} />
            </button>
          </span>
        ))}
      </div>
    </div>
  )
}
